export const serverURL = "https://imis.mzuni.ac.mw/api";
// export const serverURL = "http://127.0.0.1:8000/api";
